/**
 * @file index.tsx
 *
 * @fileoverview Renders a organization icon.
 */

import { OfficeIcon } from '~/vcl/icons/Office';

interface OrganizationIconSlotProps {
  /**
   * The width of the icon.
   */
  width?: string;
  /**
   * The height of the icon.
   */
  height?: string;
}

export default function OrganizationIconSlot({
  width,
  height,
}: OrganizationIconSlotProps) {
  return (
    <OfficeIcon {...(width ? { width } : {})} {...(height ? { height } : {})} />
  );
}
export { OrganizationIconSlot };
